import React from 'react';
import AsyncCreateDashboardGadgetModal from '@atlassian/jira-dashboard-create-dashboard-gadget-modal/src/async.tsx';
import type { FilterIdOrJql } from '@atlassian/jira-dashboard-create-dashboard-gadget-modal/src/types.tsx';
import { useRouterActions } from '@atlassian/react-resource-router';
import type { ModalProps } from '../../types.tsx';

// eslint-disable-next-line jira/export/restrict-types-re-export
export type CreateDashboardGadgetModalOptions = FilterIdOrJql;

export type Props = CreateDashboardGadgetModalOptions & ModalProps;

const CreateDashboardGadgetModal = ({
	onClose,
	onInitiateFailed: __,
	onInitiateSuccess: ___,
	...filterIdOrJql
}: Props) => {
	const { push } = useRouterActions();

	const onSuccess = (dashboardId: string) => {
		onClose();
		push(`/jira/dashboards/${dashboardId}/edit`);
	};

	return (
		<AsyncCreateDashboardGadgetModal onSuccess={onSuccess} onCancel={onClose} {...filterIdOrJql} />
	);
};

export default CreateDashboardGadgetModal;
